import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { WorkloadClient } from '@internal/workload-api-helper';
import { Grid, Typography } from '@material-ui/core';

import { TextFieldElement } from 'react-hook-form-mui';
import { CustomTooltip, useStyles } from '../CustomTooltip';
import { ApiValidation } from '../types';
import { validateQuestion } from '../utils/checks';

export type RepositoryInputProps = {
  apiValidation: ApiValidation;
  existingRepository?: string;
};

export function RepositoryInput(props: RepositoryInputProps) {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);
  const workloadClient = new WorkloadClient(configApi, oauthApi);

  const label = 'GitHub organization/repository name';
  let placeholder = label;
  if (props.existingRepository) {
    placeholder = `Current: ${props.existingRepository}`;
  }

  return (
    <Grid container style={{ padding: 5 }} justifyContent="space-between">
      <Grid item xs={11}>
        <TextFieldElement
          name="repository"
          label={label}
          variant="outlined"
          className={classes.root}
          placeholder={placeholder}
          validation={{
            validate: async value => {
              if (value) {
                return await validateQuestion(
                  'repository',
                  value,
                  props.apiValidation,
                  workloadClient,
                  true,
                );
              }
              return true;
            },
          }}
          fullWidth
        />
      </Grid>
      <Grid container item xs={1} alignItems="center">
        <CustomTooltip
          detail={
            <Typography variant="body1">
              Example:{' '}
              <code>
                principalinformationservices-emu/aws-workload-threepet-infra
              </code>
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
}
